import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { buscaGlobal } from '../../../api/busca';
import './BuscaGlobal.css';

// Paleta de comando global (Fase 6). Abre com Ctrl/Cmd+K.
function BuscaGlobal() {
  const history = useHistory();
  const [aberto, setAberto] = useState(false);
  const [q, setQ] = useState('');
  const [grupos, setGrupos] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const [ativo, setAtivo] = useState(0);
  const inputRef = useRef(null);
  const debounceRef = useRef(null);

  const abrir = useCallback(() => setAberto(true), []);
  const fechar = useCallback(() => { setAberto(false); setQ(''); setGrupos([]); setAtivo(0); }, []);

  // Atalho global Ctrl/Cmd+K
  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && (e.key === 'k' || e.key === 'K')) {
        if (!localStorage.getItem('token')) return;
        e.preventDefault();
        setAberto((v) => !v);
      } else if (e.key === 'Escape' && aberto) {
        fechar();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [aberto, fechar]);

  useEffect(() => { if (aberto && inputRef.current) inputRef.current.focus(); }, [aberto]);

  // Busca com debounce
  useEffect(() => {
    if (!aberto) return undefined;
    if (debounceRef.current) clearTimeout(debounceRef.current);
    if (!q || q.trim().length < 2) { setGrupos([]); setCarregando(false); return undefined; }
    setCarregando(true);
    debounceRef.current = setTimeout(async () => {
      const r = await buscaGlobal(q, 5);
      setGrupos(r.grupos || []);
      setAtivo(0);
      setCarregando(false);
    }, 250);
    return () => { if (debounceRef.current) clearTimeout(debounceRef.current); };
  }, [q, aberto]);

  // Lista plana para navegação por teclado
  const planos = [];
  grupos.forEach((g) => g.itens.forEach((it) => planos.push({ ...it, grupoIcone: g.icone })));

  const irPara = useCallback((item) => {
    if (!item || !item.rota) return;
    fechar();
    history.push(item.rota);
  }, [fechar, history]);

  const onKeyInput = (e) => {
    if (e.key === 'ArrowDown') { e.preventDefault(); setAtivo((i) => Math.min(i + 1, Math.max(planos.length - 1, 0))); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setAtivo((i) => Math.max(i - 1, 0)); }
    else if (e.key === 'Enter') { e.preventDefault(); if (planos[ativo]) irPara(planos[ativo]); }
  };

  if (!aberto) return null;

  let idxGlobal = -1;
  return (
    <div className="busca-global-overlay" onClick={fechar}>
      <div className="busca-global" onClick={(e) => e.stopPropagation()}>
        <div className="busca-global-input-wrap">
          <i className="fas fa-search busca-global-lupa" />
          <input
            ref={inputRef}
            type="text"
            className="busca-global-input"
            placeholder="Buscar chamados, artigos, sistemas, hardware, sprints…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            onKeyDown={onKeyInput}
          />
          <span className="busca-global-esc">ESC</span>
        </div>

        <div className="busca-global-resultados">
          {carregando && <div className="busca-global-msg"><i className="fas fa-spinner fa-spin me-2" />Buscando…</div>}
          {!carregando && q.trim().length >= 2 && planos.length === 0 && (
            <div className="busca-global-msg">Nenhum resultado para “{q}”.</div>
          )}
          {!carregando && q.trim().length < 2 && (
            <div className="busca-global-dica">Digite ao menos 2 caracteres. Use ↑ ↓ para navegar e Enter para abrir.</div>
          )}
          {grupos.map((g) => (
            <div key={g.tipo} className="busca-global-grupo">
              <div className="busca-global-grupo-titulo"><i className={`fas ${g.icone} me-2`} />{g.rotulo}</div>
              {g.itens.map((it) => {
                idxGlobal += 1;
                const meuIdx = idxGlobal;
                return (
                  <button
                    key={`${it.tipo}:${it.id}`}
                    type="button"
                    className={`busca-global-item ${meuIdx === ativo ? 'ativo' : ''}`}
                    onMouseEnter={() => setAtivo(meuIdx)}
                    onClick={() => irPara(it)}
                  >
                    <span className="busca-global-item-titulo">{it.titulo}</span>
                    {it.subtitulo && <span className="busca-global-item-sub">{it.subtitulo}</span>}
                  </button>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default BuscaGlobal;
